module.exports = __webpack_public_path__ + "img/laptop.9eb9e027.png";